import { log, callAdminAjax, createTranslator } from "./utils";
import { renderMediaGallery } from "./postMediaGallery";

const $ = window.jQuery;
const t = createTranslator('common');

let inFlightUploads = 0;

let maxUploadsPerPost = 100;
if(typeof window.ironman.appConfig.maxMediaUploadsPerPost !== 'undefined') {
    maxUploadsPerPost = window.ironman.appConfig.maxMediaUploadsPerPost;
}

let maxUploadsPerItinerary = 100;
if(typeof window.ironman.userData.permissions !== 'undefined' && typeof window.ironman.userData.permissions.maxMediaUploadsPerItinerary !== 'undefined') {
    maxUploadsPerItinerary = window.ironman.userData.permissions.maxMediaUploadsPerItinerary;
}

export function initUserMediaUploads() {
    log('User media uploads module initialized');
    
    let $root = $(document);
    attachUserMediaUploadWidget($root);
}

/**
 * Attach the user media upload widget to an element.
 * @param {jQuery} $root - The root element to attach the user media upload widget to.
 * @returns {void}
 * 
 * Note: If you want to attach the user media upload widget to a new element, you can do the following:
 * const $newContent = $(html);
 * $('#someContainer').append($newContent);
 * attachUserMediaUploadWidget($newContent);
 */
function attachUserMediaUploadWidget($root) {
    const storage = window.ironman.appConfig.userMediaStorage;

    // Get user upload permissions for the post type.
    const postType = window.ironman.postType || 'post';
    let allowedMediaUploadTypes = ['image', 'video'];

    if(typeof window.ironman.userData.permissions.limitMediaUploadTypesByPostType[postType] !== 'undefined') {
        allowedMediaUploadTypes = window.ironman.userData.permissions.limitMediaUploadTypesByPostType[postType];
    }

    log('allowedMediaUploadTypes:', allowedMediaUploadTypes);

    //User Media Upload Button
    $root.find('[data-action="userMediaUpload"]').each(function() {
        if(window.ironman.userData.loggedInUser === false) {
            alert(t('youMustBeLoggedInToUploadMedia'));
            return;
        }
        const $button = $(this);
        if ($button.data('bytescaleInitialized')) {
            return;
        }
        $button.data('bytescaleInitialized', true);
        const callback = $button.attr('data-afterUploadCallback');
        if(storage === 'bytescale') {
            attachBytescaleUploadWidget($button, callback, allowedMediaUploadTypes);
        } else {
            log('User media storage not supported:', storage);
        }
    });
}

function attachBytescaleUploadWidget($button, callback, allowedMediaUploadTypes) {
    // Attach the bytescale upload widget to the button.
    // log('Attaching bytescale upload widget to button:', $button);

    //Prevent default click behavior
    $button.on('click', function(e) {
        e.preventDefault();
        return false;
    });

    // Get the folder path.
    let folderPath = window.ironman.userData.bytescaleImageUploadFolder;
    if(typeof window.ironman.privateUploadFolder !== 'undefined' && window.ironman.privateUploadFolder === true) {
        folderPath = '/private' + folderPath;
    }

    //Attach the bytescale upload widget to the button.
    $button.bytescaleUploadWidget({
        // -----
        // Configuration:
        // https://www.bytescale.com/docs/upload-widget#configuration
        // -----
        apiKey: "public_FW25cBjFgrGxxvcgphYXXKYnZDB5",
        "locale": window.ironman.translate.bytescaleLocale,
        "maxFileCount": 12,
        "maxFileSizeBytes": 100485760,
        "metadata": {
            // "originalFilename": "{ORIGINAL_FILE_NAME}{ORIGINAL_FILE_EXT}"
        },
        "mimeTypes": getAllowedMimeTypes(false),
        "path": {
            "fileName": "{UNIQUE_DIGITS_8}_{UTC_TIME_TOKEN}{ORIGINAL_FILE_EXT}",
            // "fileNameFallback": "image.jpg",
            "fileNameVariablesEnabled": true,
            "folderPath": folderPath,
            "folderPathVariablesEnabled": true
        },
        "styles": {
            "colors": {
                "active": "#528fff",
                "error": "#d23f4d",
                "primary": "#377dff",
                "shade100": "#333",
                "shade200": "#7a7a7a",
                "shade300": "#999",
                "shade400": "#a5a6a8",
                "shade500": "#d3d3d3",
                "shade600": "#dddddd",
                "shade700": "#f0f0f0",
                "shade800": "#f8f8f8",
                "shade900": "#fff"
            },
            "fontFamilies": {
                "base": "Inter, -apple-system, blinkmacsystemfont, Segoe UI, helvetica, arial, sans-serif"
            }
        },
        onInit: () => {
            //Every time the upload widget is OPENED.
            // log('onInit'); 

            inFlightUploads = 0;

        },
        onPreUpload: (file) => {
            log('onPreUpload', file);
            
            // Perform pre-upload validation.

            // Check album size limits.
            let currentItems = 0;
            for (const key in window.ironman.postMediaGallery) {
                const arr = window.ironman.postMediaGallery[key];
                if (Array.isArray(arr)) {
                    currentItems += arr.length;
                }
            }
            log('currentItems:', currentItems);
            log('inFlightUploads:', inFlightUploads);

            if(window.ironman.postType == 'itinerary') {
                log('maxUploadsPerItinerary:', maxUploadsPerItinerary);
                if(currentItems + inFlightUploads >= maxUploadsPerItinerary) {
                    alert(t('youHaveReachedTheMaximumNumberOfMediaUploadsForThisItinerary'));
                    return { errorMessage: 'Upgrade to upload more media.' };
                }
            } else {
                log('maxUploadsPerPost:', maxUploadsPerPost);
                if(currentItems + inFlightUploads >= maxUploadsPerPost) {
                    alert(t('youHaveReachedTheMaximumNumberOfMediaUploadsForThisPost'));
                    return { errorMessage: 'This album has reached the maximum number of uploads.' };
                }
            }

            // Check file type limits.
            if (file.type.startsWith("video/")) {
                if(!allowedMediaUploadTypes.includes('video')) {
                    // showUpgradeModal(); // your UI
                    alert(t('videoUploadsAreNotAllowedForYourUserLevel'));
                    return { errorMessage: 'Upgrade to upload videos.' };
                }
            }
            if (file.type.startsWith("image/")) {
                if(!allowedMediaUploadTypes.includes('image')) {
                    // showUpgradeModal(); // your UI
                    alert(t('imageUploadsAreNotAllowedForYourUserLevel'));
                    return { errorMessage: 'Upgrade to upload images.' };
                }
            }

            // Increment the in-flight uploads count.
            inFlightUploads++;
        },
        onComplete: files => {
            // Reset the in-flight uploads count.
            inFlightUploads = 0;

            if (files.length === 0) {
                // alert('No files selected.')
            } else {
                if(callback == 'handleStageUserMedia') {
                    //Get stage id from button data-id
                    // const stage_id = $button.attr('data-stage_id');
                    // handleStageUserMedia(files, stage_id);
                } else if(callback == 'handleAddUserMediaToPostMediaGallery') {
                    let child_id = null;
                    if($button.attr('data-child_id')) {
                        child_id = parseInt($button.attr('data-child_id'));
                    }
                    handleAddUserMediaToPostMediaGallery(files, $button, child_id, true);
                } else {
                    log('No callback found.');
                    log($(this));
                }
            }
            return false;
        }
    });
}


//Handle Post Album Media Upload
function handleAddUserMediaToPostMediaGallery(files, $button, child_id=null, fetchUpdatedPostMediaGallery=false) {
    log('handleAddUserMediaToPostMediaGallery');
    log(files);
    // alert(files.map(f => f.fileUrl).join("\n"));
    // alert(files.length.toString()+' files uploaded successfully.');

    //Update post meta
    var data = {
        'post_id': window.ironman.postId,
        'child_id': child_id,
        'snonce': window.ironman.snonce,
        'media_gallery_nonce': window.ironman.postMediaGalleryNonce
    };

    var fileData = [];
    $.each(files, function(index, file) {
        log(file);
        //add file to files array
        fileData.push({
            'path': file.filePath,
            'mime_type': file.originalFile.file.type
        });

    });

    //add file paths to data
    data['fileData'] = fileData;

    // Call the admin ajax function. Use callbacks to handle the response.
    callAdminAjax('addMediaToPostMediaGallery', data, 'addMediaToPostMediaGallery', {
        onSuccess: (response) => {
            if(response.success === true) {
                log('Media uploaded successfully.');

                if(fetchUpdatedPostMediaGallery) {
                    // Update the window.ironman.postMediaGallery with the new media items.
                    // Now included as part of the response.
                    window.ironman.postMediaGallery = response.data.post_media_gallery;
                    window.ironman.postMediaGalleryCounts = response.data.post_media_gallery_counts;
                    renderMediaGallery(child_id);
                }
            } else {
                log('error uploading media.');
                alert(t('errorUploadingMedia'));
            }
        },
        onFail: (error) => {
            log('error uploading media.');
            alert(t('errorUploadingMedia'));
        }
    }, 'non-blocking', t('uploadingMediaSpinnerMessage'));
}

// Update a post media gallery item.
export async function updatePostMediaGalleryItem(gallery_item_id, mission, new_value=null) {
    log('function: updatePostMediaGalleryItem', mission);

    const allowed_missions = ['set_primary', 'add_caption', 'remove', 'like', 'unlike', 'update_child', 'add_tag', 'remove_tag', 'duplicate_media'];
    let notification_type = 'page-blocking';
    if(!allowed_missions.includes(mission)) {
        log('Invalid mission.');
        return { success: false, error: 'Invalid mission.' };
    }

    var data = {
        'post_id': window.ironman.postId,
        'gallery_item_id': gallery_item_id,
        'mission': mission,
        'snonce': window.ironman.snonce,
        'media_gallery_nonce': window.ironman.postMediaGalleryNonce
    };

    // Handle missions with new_value parameter
    if(mission === 'add_caption') {
        if(new_value === null) {
            log('Caption is required.');
            return;
        }
        // Enforce caption max length
        new_value = new_value.substring(0, 300);
        data['caption'] = new_value;
        notification_type = 'non-blocking';
    } else if(mission === 'update_child') {
        // child_id can be null to unattach from stage OR a number to attach to a stage.
        if(new_value !== false) {
            new_value = parseInt(new_value);
            if(isNaN(new_value)) {
                log('Invalid child_id.');
                return;
            }
        }
        data['child_id'] = new_value;
    } else if(mission === 'add_tag' || mission === 'remove_tag') {
        if(new_value === null) {
            log('Tag user id is required for adding or removing tags.');
            return;
        }
        // Validate tag user id is a number.
        new_value = parseInt(new_value);
        if(isNaN(new_value)) {
            log('Invalid tag user id.');
            return;
        }
        data['tag_user_id'] = new_value;
        notification_type = 'non-blocking';
    } else if(mission === 'duplicate_media') {
        if(new_value === null) {
            log('Destination post id is required for duplicating media items.');
            return;
        }
        // Validate destination post id is a number.
        new_value = parseInt(new_value);
        if(isNaN(new_value)) {
            log('Invalid destination post id.');
            return;
        }
        data['destination_post_id'] = new_value;
    } else if (mission === 'like' || mission === 'unlike') {
        notification_type = null; // No notification is needed for like/unlike
    }

    // Call the admin ajax function. Use callbacks to handle the response.
    const response = await callAdminAjax('updatePostMediaGalleryItem', data, 'updatePostMediaGalleryItem_'+mission, null, notification_type, t('savingChangesSpinnerMessage'));

    return response;
}

export async function createMediaItemReport(gallery_item_id, reason, comment) {
    var data = {
        'post_id': window.ironman.postId,
        'gallery_item_id': gallery_item_id,
        'reason': reason,
        'comment': comment,
        '_ajax_nonce': window.ironman.gnonce,
    };
    const response = await callAdminAjax('createMediaItemReport', data, 'createMediaItemReport', null, 'page-blocking', t('creatingMediaReportSpinnerMessage'));
    return response;
}

function getAllowedMimeTypes(forLoggedInUser=false) {
    const allowedMimeTypes = [];
    let types = ['image', 'video'];
    if(forLoggedInUser && window.ironman.userData.permissions.allowedMediaUploadTypes) {
        types = window.ironman.userData.permissions.allowedMediaUploadTypes;
    }
    if(types.includes('image')) {
        const imageMimeTypes = window.ironman.appConfig.mimeTypes.image;
        imageMimeTypes.forEach(mimeType => {
            allowedMimeTypes.push('image/'+mimeType);
        });
    }
    if(types.includes('video')) {
        const videoMimeTypes = window.ironman.appConfig.mimeTypes.video;
        videoMimeTypes.forEach(mimeType => {
            allowedMimeTypes.push('video/'+mimeType);
        });
    }
    return allowedMimeTypes;
}